export default "__VITE_ASSET__CvV91tFm__"